import type { Repositories } from '@cvo/domain/api/repositories/Repositories';

/** Shortcut to use the inject api module.
 * Example usage:
 * ```ts
 * const api = useApi();
 * await api.plans.list({ ... });
 * ```
 */
export function useApi(): Repositories {
  const { $api } = useNuxtApp();
  return $api;
}